import WeightCell from './container';

export default WeightCell;
